import * as React from "react";

function Calendar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="none" d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path fill="none" d="M16 2V6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path fill="none" d="M8 2V6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path fill="none" d="M3 10H21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const MemoCalendar = React.memo(Calendar);
export default MemoCalendar;
